export default "__VITE_ASSET__ckQiyfs4__"